module.exports = __webpack_public_path__ + "static/media/map_placeholder.70563928.png";